import React from 'react';
import ReactPlayer from 'react-player';

const VideoPlayer = ({ url, onPlay }) => {
    return (
        <div className="video-container">
            <ReactPlayer
                url={url}
                className='react-player'
                width='100%'
                height='100%'
                controls={true}
                onPlay={onPlay}
                config={{
                    youtube: {
                        playerVars: { modestbranding: 1 }
                    }
                }}
            />
        </div>
    );
};

export default VideoPlayer;